import React from 'react'

const HomeNewslettersignupForm = () => {
  return (
    <div className="letter_button">
        <a href="https://forms.gle/YZMnrKVWbuE9q1NK8" rel="noopener noreferrer" target='_blank'><button>Join the waitlist</button></a>
    </div>
  )
}

export default HomeNewslettersignupForm